import React from 'react';

const AiStatsModal = ({ isOpen, onClose, stats, t }) => {
    if (!isOpen || !stats) return null;

    const totalTimeMs = (stats.databaseTimeMs || 0) + (stats.apiTimeMs || 0);
    const totalTimeSec = (totalTimeMs / 1000).toFixed(2);

    const modalStyles = `
        .stats-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(14, 44, 83, 0.4);
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2200;
            padding: 20px;
        }
        .stats-modal-card {
            background: #ffffff;
            border: 1px solid rgba(235, 217, 197, 0.5);
            border-radius: 20px;
            max-width: 480px;
            width: 100%;
            box-shadow: 0 25px 60px rgba(14, 44, 83, 0.15);
            overflow: hidden;
            display: flex;
            flex-direction: column;
        }
        .stats-modal-header {
            padding: 18px 24px;
            border-bottom: 1px solid rgba(235, 217, 197, 0.4);
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #fdfaf5;
        }
        .stats-modal-title {
            font-size: 16px;
            font-weight: 700;
            color: #0e2c53;
            display: flex;
            align-items: center;
            gap: 8px;
            margin: 0;
            font-family:"Droid Arabic Naskh", sans-serif;
        }
        .stats-modal-title i {
            color: #92278f;
            margin-left: 6px;
        }
        .stats-modal-close-btn {
            background: transparent;
            border: none;
            color: #8c857b;
            cursor: pointer;
            font-size: 18px;
            transition: color 0.2s ease;
            outline: none;
            width: auto;
        }
        .stats-modal-close-btn:hover {
            color: #ff5200;
        }
        .stats-modal-body {
            padding: 20px 24px;
            overflow-y: auto;
            max-height: 70vh;
        }
        .stats-modal-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
            text-align: right;
            direction: rtl;
        }
        @media (max-width: 480px) {
            .stats-modal-grid {
                grid-template-columns: 1fr;
            }
        }
        .stats-modal-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            padding: 10px 14px;
            background: #fdfaf5;
            border-radius: 12px;
            border: 1px solid rgba(235, 217, 197, 0.2);
            font-size: 12px;
            width: 100%;
        }
        .stats-modal-item-label-group {
            display: flex;
            align-items: center;
            gap: 8px;
        }
        .stats-modal-item i {
            font-size: 13px;
            color: #92278f;
            margin-left: 6px;
        }
        .stats-modal-item .label {
            color: #8c857b;
            font-weight: 500;
            font-family: "Droid Arabic Naskh", sans-serif;
        }
        .stats-modal-item .value {
            color: #0e2c53;
            font-weight: 700;
            font-family: monospace, sans-serif;
        }
        .stats-modal-item .value.cache-status {
            font-family: inherit;
            color: #8dc63f;
        }
    `;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: modalStyles }} />
            <div className="stats-modal-overlay animate__animated animate__fadeIn animate__faster" onClick={onClose}>
                <div className="stats-modal-card animate__animated animate__zoomIn animate__faster" onClick={(e) => e.stopPropagation()}>
                    <div className="stats-modal-header">
                        <h3 className="stats-modal-title">
                            <i className="fal fa-analytics"></i>
                            {t("Pages.Chatbot.TotalTime") || "وقت الاستجابة الكلي"} ({totalTimeSec} {t("Pages.Chatbot.Sec") || "ثانية"})
                        </h3>
                        <button
                            className="stats-modal-close-btn"
                            onClick={onClose}
                            title={t("cancel") || "إلغاء"}
                        >
                            <i className="fal fa-times"></i>
                        </button>
                    </div>
                    <div className="stats-modal-body">
                        <div className="stats-modal-grid">
                            {(stats.model || stats.Model) && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-robot"></i>
                                        <span className="label">{t("Pages.Chatbot.Model") || "نموذج الذكاء الاصطناعي"}</span>
                                    </div>
                                    <span className="value" style={{ textTransform: 'capitalize' }}>
                                        {stats.model || stats.Model}
                                    </span>
                                </div>
                            )}
                            {stats.databaseTimeMs !== undefined && stats.databaseTimeMs > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-database"></i>
                                        <span className="label">{t("Pages.Chatbot.DbTime") || "وقت قاعدة البيانات"}</span>
                                    </div>
                                    <span className="value">{(stats.databaseTimeMs / 1000).toFixed(2)} {t("Pages.Chatbot.Sec") || "ثانية"}</span>
                                </div>
                            )}
                            {stats.apiTimeMs !== undefined && stats.apiTimeMs > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-server"></i>
                                        <span className="label">{t("Pages.Chatbot.ApiTime") || "وقت الواجهة الذكية"}</span>
                                    </div>
                                    <span className="value">{(stats.apiTimeMs / 1000).toFixed(2)} {t("Pages.Chatbot.Sec") || "ثانية"}</span>
                                </div>
                            )}
                            {stats.sendTimeMs !== undefined && stats.sendTimeMs > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-paper-plane"></i>
                                        <span className="label">{t("Pages.Chatbot.SendTime") || "وقت الإرسال"}</span>
                                    </div>
                                    <span className="value">{(stats.sendTimeMs / 1000).toFixed(2)} {t("Pages.Chatbot.Sec") || "ثانية"}</span>
                                </div>
                            )}
                            {stats.responseTimeMs !== undefined && stats.responseTimeMs > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-reply"></i>
                                        <span className="label">{t("Pages.Chatbot.ResponseTime") || "وقت الاستجابة"}</span>
                                    </div>
                                    <span className="value">{(stats.responseTimeMs / 1000).toFixed(2)} {t("Pages.Chatbot.Sec") || "ثانية"}</span>
                                </div>
                            )}
                            {stats.serverTimeMs !== undefined && stats.serverTimeMs > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-microchip"></i>
                                        <span className="label">{t("Pages.Chatbot.ServerTime") || "وقت الخادم"}</span>
                                    </div>
                                    <span className="value">{(stats.serverTimeMs / 1000).toFixed(2)} {t("Pages.Chatbot.Sec") || "ثانية"}</span>
                                </div>
                            )}
                            {stats.sendTokens !== undefined && stats.sendTokens > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-coins"></i>
                                        <span className="label">{t("Pages.Chatbot.SendTokens") || "الرموز المرسلة"}</span>
                                    </div>
                                    <span className="value">{stats.sendTokens}</span>
                                </div>
                            )}
                            {stats.sendTokensDetails && (
                                <div className="stats-modal-item" style={{ gridColumn: "span 2", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-list-ol"></i>
                                        <span className="label">{t("Pages.Chatbot.SendTokensDetails") || "تفاصيل الرموز المرسلة"}</span>
                                    </div>
                                    <div className="value" style={{ width: "100%", display: "flex", flexDirection: "column", gap: "6px", fontSize: "11px", direction: "rtl", textAlign: "right" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed rgba(235, 217, 197, 0.4)", paddingBottom: "4px" }}>
                                            <span style={{ color: "#8c857b" }}>{t("Pages.Chatbot.SystemInstructionTokenLabel") || "تعليمات النظام"}</span>
                                            <span style={{ fontWeight: "700" }}>{stats.sendTokensDetails.systemInstruction || 0}</span>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed rgba(235, 217, 197, 0.4)", paddingBottom: "4px" }}>
                                            <span style={{ color: "#8c857b" }}>{t("Pages.Chatbot.ContextTokenLabel") || "نصوص المساعدة"}</span>
                                            <span style={{ fontWeight: "700" }}>{stats.sendTokensDetails.context || 0}</span>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed rgba(235, 217, 197, 0.4)", paddingBottom: "4px" }}>
                                            <span style={{ color: "#8c857b" }}>{t("Pages.Chatbot.LessonsListTokenLabel") || "قائمة الدروس المرفقة"}</span>
                                            <span style={{ fontWeight: "700" }}>{stats.sendTokensDetails.lessonsList || 0}</span>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "4px" }}>
                                            <span style={{ color: "#8c857b" }}>{t("Pages.Chatbot.QuestionTokenLabel") || "سؤال/إجابة الطالب"}</span>
                                            <span style={{ fontWeight: "700" }}>{stats.sendTokensDetails.question || 0}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {stats.receivedTokens !== undefined && stats.receivedTokens > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-coins-gold"></i>
                                        <span className="label">{t("Pages.Chatbot.ReceivedTokens") || "الرموز المستلمة"}</span>
                                    </div>
                                    <span className="value">{stats.receivedTokens}</span>
                                </div>
                            )}
                            {stats.bandwidth !== undefined && stats.bandwidth > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-signal"></i>
                                        <span className="label">{t("Pages.Chatbot.Bandwidth") || "حجم البيانات المستهلكة"}</span>
                                    </div>
                                    <span className="value">{stats.bandwidth.toFixed(2)} KB</span>
                                </div>
                            )}
                            {stats.price !== undefined && stats.price !== null && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-usd-circle"></i>
                                        <span className="label">{t("Pages.Chatbot.Price") || "التكلفة"}</span>
                                    </div>
                                    <span className="value">${stats.price.toFixed(6)}</span>
                                </div>
                            )}
                            {stats.search_topic_token !== undefined && stats.search_topic_token !== null && stats.search_topic_token > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-tags"></i>
                                        <span className="label">{t("Pages.Chatbot.SearchTopicTokens") || "رموز مطابقة المواضيع"}</span>
                                    </div>
                                    <span className="value">{stats.search_topic_token}</span>
                                </div>
                            )}
                            {stats.search_topic_price !== undefined && stats.search_topic_price !== null && stats.search_topic_price > 0 && (
                                <div className="stats-modal-item">
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-money-bill-wave"></i>
                                        <span className="label">{t("Pages.Chatbot.SearchTopicPrice") || "تكلفة مطابقة المواضيع"}</span>
                                    </div>
                                    <span className="value">${stats.search_topic_price.toFixed(6)}</span>
                                </div>
                            )}
                            {(() => {
                                const isCached = stats.isFromCache !== undefined ? stats.isFromCache : stats.IsFromCache;
                                return (
                                    <>
                                        {isCached !== undefined && (
                                            <div className="stats-modal-item">
                                                <div className="stats-modal-item-label-group">
                                                    <i className="fal fa-history"></i>
                                                    <span className="label">{t("Pages.Chatbot.IsFromCache") || "من الذاكرة المؤقتة"}</span>
                                                </div>
                                                <span className="value cache-status">
                                                    {isCached
                                                        ? t("Pages.Chatbot.CachedQuery") || "استعلام مخزن"
                                                        : t("Pages.Chatbot.NewQuery") || "استعلام جديد"}
                                                </span>
                                            </div>
                                        )}
                                        {isCached && stats.cacheRemainingTime !== undefined && stats.cacheRemainingTime !== null && (
                                            <div className="stats-modal-item">
                                                <div className="stats-modal-item-label-group">
                                                    <i className="fal fa-hourglass-half"></i>
                                                    <span className="label">{t("Pages.Chatbot.CacheRemaining") || "الوقت المتبقي في الذاكرة"}</span>
                                                </div>
                                                <span className="value">{stats.cacheRemainingTime} {t("Pages.Chatbot.Sec") || "ثانية"}</span>
                                            </div>
                                        )}
                                    </>
                                );
                            })()}
                            {(stats.prompt || stats.Prompt) && (
                                <div className="stats-modal-item" style={{ gridColumn: "span 2", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-comment-alt-lines"></i>
                                        <span className="label">{t("Pages.Chatbot.PromptSent")}</span>
                                    </div>
                                    <div className="value" style={{
                                        width: "100%",
                                        maxHeight: "150px",
                                        overflowY: "auto",
                                        whiteSpace: "pre-wrap",
                                        fontFamily: "monospace",
                                        fontSize: "11px",
                                        background: "rgba(14, 44, 83, 0.03)",
                                        border: "1px dashed rgba(235, 217, 197, 0.6)",
                                        borderRadius: "8px",
                                        padding: "8px 12px",
                                        color: "#0e2c53",
                                        direction: "rtl",
                                        textAlign: "right",
                                        lineHeight: "1.5"
                                    }}>
                                        {stats.prompt || stats.Prompt}
                                    </div>
                                </div>
                            )}
                            {stats.searchWords && stats.searchWords.length > 0 && (
                                <div className="stats-modal-item" style={{ gridColumn: "span 2", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                                    <div className="stats-modal-item-label-group">
                                        <i className="fal fa-search"></i>
                                        <span className="label">{t("Pages.Chatbot.SearchWords") || "كلمات البحث"}</span>
                                    </div>
                                    <div className="value" style={{ direction: "rtl", display: "flex", flexWrap: "wrap", gap: "6px", width: "100%", justifyContent: "flex-start" }}>
                                        {stats.searchWords.map((word, wIdx) => (
                                            <span key={wIdx} className="search-word-badge" style={{ background: "rgba(146, 39, 143, 0.08)", padding: "4px 10px", borderRadius: "8px", fontSize: "11px", color: "#92278f", fontWeight: "600" }}>
                                                {word}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AiStatsModal;
